import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX, FiTrash2, FiShoppingBag, FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const CartDrawer = ({ isOpen, onClose, items, onRemove }) => {
  const total = items.reduce((sum, item) => sum + (item.price * (item.quantity || 1)), 0);

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[150]"
          />
          <motion.div
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            exit={{ x: '100%' }}
            transition={{ type: 'spring', damping: 25, stiffness: 200 }}
            className="fixed right-0 top-0 h-full w-full max-w-md bg-asphalt-dark z-[160] shadow-2xl border-l border-white/5 flex flex-col"
          >
            <div className="p-6 border-b border-white/10 flex justify-between items-center bg-asphalt">
              <div className="flex items-center gap-3">
                <SafeIcon icon={FiShoppingBag} className="text-signal text-xl" />
                <h2 className="text-xl font-black uppercase tracking-tighter">Current Loadout</h2>
              </div>
              <button onClick={onClose} className="p-2 hover:bg-white/5 transition-colors" aria-label="Close cart">
                <SafeIcon icon={FiX} className="text-2xl" />
              </button>
            </div>

            <div className="flex-grow overflow-y-auto p-6 space-y-6">
              {items.length === 0 ? (
                <div className="h-full flex flex-col items-center justify-center text-center opacity-40">
                  <SafeIcon icon={FiShoppingBag} className="text-6xl mb-4" />
                  <p className="font-black uppercase tracking-widest text-xs">Inventory Empty</p>
                </div>
              ) : (
                items.map((item, idx) => (
                  <motion.div 
                    layout
                    key={`${item.id}-${idx}`}
                    className="flex gap-4 group"
                  >
                    <div className="w-20 h-20 bg-asphalt rounded-sm overflow-hidden shrink-0 border border-white/5">
                      <img src={item.img} alt={item.name} className="w-full h-full object-cover grayscale" />
                    </div>
                    <div className="flex-grow">
                      <h4 className="text-sm font-black uppercase tracking-wider">{item.name}</h4>
                      <p className="text-xs text-gray-500 mt-1">{item.category || 'System Component'}</p>
                      <div className="flex justify-between items-end mt-2">
                        <span className="text-signal font-black">${item.price.toFixed(2)}</span>
                        <button 
                          onClick={() => onRemove(idx)}
                          className="text-gray-600 hover:text-red-500 transition-colors p-1"
                          aria-label={`Remove ${item.name}`}
                        >
                          <SafeIcon icon={FiTrash2} />
                        </button>
                      </div>
                    </div>
                  </motion.div>
                ))
              )}
            </div>

            {items.length > 0 && (
              <div className="p-8 border-t border-white/10 bg-asphalt">
                <div className="flex justify-between items-end mb-6">
                  <span className="text-xs font-black uppercase tracking-widest text-gray-500">Total Credits</span>
                  <span className="text-3xl font-black text-white">${total.toFixed(2)}</span>
                </div>
                <button className="w-full bg-signal hover:bg-white text-white hover:text-signal py-5 font-black uppercase tracking-[0.2em] text-sm transition-all flex items-center justify-center gap-3">
                  Initiate Checkout <SafeIcon icon={FiArrowRight} />
                </button>
                <p className="text-[9px] text-gray-600 text-center mt-4 font-bold uppercase tracking-widest">
                  Secure encrypted transmission via BikeBloom Protocol
                </p>
              </div>
            )}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default CartDrawer;